import React from 'react';
import cx from 'classnames';

import styles from './styles.css';

export const buttonThemes = {
  DARK: 'DARK',
  LIGHT: 'LIGHT',
};

const Button = ({
  isDisabled,
  label,
  onClick,
  passedStyles,
  theme,
  type = 'button',
}) => {
  const buttonClasses = cx(
    {
      [styles.button]: true,
      [styles.buttonLightTheme]: theme === buttonThemes.LIGHT,
      [styles.buttonDarkTheme]: theme === buttonThemes.DARK,
      [styles.buttonIsDisabeld]: isDisabled,
    },
    passedStyles
  );

  return (
    <button
      className={buttonClasses}
      disabled={isDisabled}
      onClick={onClick}
      type={type}
    >
      <span className={styles.label}>{label}</span>
    </button>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js